import Model from "./base/model";

class   purchaseOrder extends Model {
  resourceName() {
    return "purchase_orders";
  }

  fields() {
    return {
      number:"",
      order_ids:"",
      created_at: "",
      shipper_id: "",
      orders_without_canhoto: "",
      orders: {jsonApi: "hasMany", type: "orders"},
      shipper: {jsonApi: "hasOne", type: "shippers"},
      transporter: {jsonApi: "hasOne", type: "transporters"},
      fatura_avaliable: "",
      total: "",
      value: "",
    };
  }

}


export default new purchaseOrder();
